import _extends from "@babel/runtime-corejs3/helpers/extends";
import logger from "../../../util/logger";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../hoc";
import { isYoutubeVideo, isVimeoVideo, isInstagramVideo, isVineVideo, isTwitterVideo, isFacebookVideo, isMuxVideo } from "../../../util";
import { videoServices } from "../../../enums";
import YoutubeVideo from "./youtube-video";
import InstagramVideo from "./instagram-video";
import VineVideo from "./vine-video";
import VideoGif from "./video-gif";
import TwitterVideo from "./twitter-video";
import VimeoVideo from "./vimeo-video";
import FacebookVideo from "./facebook-video";
import MuxVideo from "./mux-video";
var Video = createComponent({
  displayName: 'Video',
  defaultProps: {
    src: null,
    service: null,
    id: null,
    type: null,
    width: undefined,
    settings: {},
    status: undefined,
    poster: undefined,
    thumbnailAssetRef: undefined
  },
  propTypes: {
    src: PropTypes.string,
    service: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    settings: PropTypes.object,
    status: PropTypes.string,
    poster: PropTypes.string,
    thumbnailAssetRef: PropTypes.string,
    customVideoCheck: function customVideoCheck() {
      return function (_ref) {
        var src = _ref.src,
            service = _ref.service,
            id = _ref.id;

        if (service || id) {
          if (src) {
            return new Error('Cannot use src and service props at the same time');
          }

          if (!(service && id)) {
            return new Error('Cannot use service without id');
          }
        } else if (!src) {
          return new Error('Video needs to be called with service or src');
        }
      };
    }
  },
  render: function render(_ref2) {
    var src = _ref2.src,
        service = _ref2.service,
        type = _ref2.type,
        id = _ref2.id,
        width = _ref2.width,
        style = _ref2.style,
        settings = _ref2.settings,
        status = _ref2.status,
        poster = _ref2.poster,
        thumbnailAssetRef = _ref2.thumbnailAssetRef;

    var videoStyle = _extends({}, style, {
      width: width
    });

    logger.warn('Video: setting a "status" or "poster" attribute for non-mux videos is not currently supported.', (!!status || !!poster) && service !== videoServices.MUX && !isMuxVideo(src));
    logger.warn('You have provided a redundant "thumbnailAssetRef" prop to the element. This prop is suppose to be used only in conjunction with instagramVideo or as part of an instagram video URL.', !!thumbnailAssetRef && !(service === videoServices.INSTAGRAM || isInstagramVideo(src)));
    return /*#__PURE__*/React.createElement("div", {
      style: videoStyle
    }, service === videoServices.YOUTUBE || isYoutubeVideo(src) ? /*#__PURE__*/React.createElement(YoutubeVideo, {
      src: src,
      id: id
    }) : service === videoServices.VIMEO || isVimeoVideo(src) ? /*#__PURE__*/React.createElement(VimeoVideo, {
      src: src,
      id: id
    }) : service === videoServices.INSTAGRAM || isInstagramVideo(src) ? /*#__PURE__*/React.createElement(InstagramVideo, {
      src: src,
      id: id,
      thumbnailAssetRef: thumbnailAssetRef
    }) : service === videoServices.VINE || isVineVideo(src) ? /*#__PURE__*/React.createElement(VineVideo, {
      src: src,
      id: id
    }) : service === videoServices.TWITTER || isTwitterVideo(src) ? /*#__PURE__*/React.createElement(TwitterVideo, {
      src: src,
      id: id
    }) : service === videoServices.FACEBOOK || isFacebookVideo(src) ? /*#__PURE__*/React.createElement(FacebookVideo, {
      src: src,
      id: id
    }) : service === videoServices.MUX || isMuxVideo(src) ? /*#__PURE__*/React.createElement(MuxVideo, {
      src: src,
      id: id,
      width: width,
      settings: settings,
      status: status,
      poster: poster
    }) : type === videoServices.GIF ? /*#__PURE__*/React.createElement(VideoGif, {
      src: src,
      width: width
    }) : /*#__PURE__*/React.createElement("video", {
      controls: true,
      src: src,
      width: width,
      style: {
        maxWidth: '100%'
      }
    }));
  }
});
export default whitelistStyles(['width'])(Video);
//# sourceMappingURL=video.js.map